module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.404a5255.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.eot
// module id = 2528
// module chunks = 7